import Field from "mson/lib/fields/field";
import { TextField } from "mson/lib/fields";
import Form from "mson/lib/form";
import compiler from "mson/lib/compiler";

export default class SearchFieldsField extends Field {
  _className = "SearchFieldsField";

  _create(props) {
    super._create(props);

    this.set({
      schema: new Form({
        fields: [
          new TextField({
            name: "ready",
          }),
          new TextField({
            name: "processor",
          }),
        ],
      }),
    });
  }

  _setRequired(/* required */) {
    // Do nothing as we don't want to report any errors as this prop doesn't apply
  }
}

compiler.registerComponent("SearchFieldsField", SearchFieldsField);
